import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { CoursesService } from '../../../service/courses.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AcademicsService } from 'src/app/service/academics.service';
declare var $: any;

@Component({
  selector: 'app-academic-calendar',
  templateUrl: './academic-calendar.component.html',
  styleUrls: ['./academic-calendar.component.scss']
})
export class AcademicCalendarComponent implements OnInit {
  types:any;
  currentType:any;
  typeNameArTemp:any;
  showLoader: boolean = false;
  calendars: any;
  calendarsTemp:any;
  currentCourseName = "";
  currentCourseId = 0;

  constructor(private toastrService: ToastrService, public coursesService: CoursesService, public globals: Globals, private router: Router
    , public translate: TranslateService,
    private academicsService:AcademicsService) { }

  ngOnInit(): void {
  //  this.getAllTypes();
    // Listen for language change to update table
    this.showLoader=true;
    this.calendars = [];
    //this.calendarsTemp=[];
    this.getAllCalenderDayType();
    
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
    });
    this.showLoader=false;
  }
  getAllCalenderDayType() {
    this.showLoader = true;
    this.academicsService.getAllCalenderDayType()
      .subscribe(
        data => {
          this.types = data;
          this.getAllCalendars();
        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false

        },
        () => this.showLoader = false
      );

  }

  getAllCalendars() {
    this.showLoader = true;
    this.academicsService.getAllCalender()
      .subscribe(
        data => {
        console.log("data before : "+data[0]);
         this.calendarsTemp = data.map((element: any) => {
          console.log("data before 1 : "+element.cdaytypeid);
          this.currentType = this.types.filter((i: any) => i.id == element.cdaytypeid)[0];
          return  {id:element.id,remarks:element.remarks,
            effectiveFrom:element.effectiveFrom,effectiveTo:element.effectiveTo,
            repeatsFlag:element.repeatsFlag,frequency:element.frequency,
            active:element.active,
            cdaytypeid:element.cdaytypeid,typeNameAr:this.currentType.cdayNameAr,
            typeNameEn:this.currentType.cdayNameEn};
           });
          this.calendars=this.calendarsTemp;
          /// console.log("data3"+this.calendarsTemp);
           this.updateTable();
          
         // console.log("data3"+this.calendarsTempp[0].id);
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false
        },
        () => this.showLoader = false
      );


  }

   getTypeById(typeId: number){
    this.academicsService.getCalenderDayTypeById(typeId).subscribe(
      data => {
        this.calendarsTemp = this.calendarsTemp.map((clender: any) => {
          if (clender.cdaytypeid == typeId) {
            console.log("data"+data.cdayNameAr);
            return{ id:clender.id,cdaytypeid:clender.cdaytypeid,typeNameAr :data.cdayNameAr,typeNameEn :data.cdayNameEn};
          } else {
            return clender
          }
        });
      },
      error => {
       // this.toastr.error(`can't get question#${questionId}`);
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'enarabic',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7]
          }
        }],
      });
    }, 1);
  }
  // getCurrentCourse(courseId: any) {
  //   this.currentCourseName = this.courses.filter((i: any) => i.id == courseId)[0].name;
  //   this.currentCourseId = courseId;
  // }

  editCourse(id: any) {
    this.router.navigate(
      ['/enrolment/update-course'],
      { queryParams: { courseId: id } });
  }

  // deleteCourse(id: any) {
  //   this.systemService.deleteCountry(id)
  //     .subscribe(
  //       data => {
  //         window.location.reload();
  //       },
  //       error => {
  //         this.toastrService.show(this.translate.instant('CAN_NOT_DELETE'));

  //       }
  //     );
  // }

}

